import React, { useEffect, useState } from "react";
// import { LanguageContext } from "../LanguagesContext";
import { useTranslation } from 'react-i18next';
import axios from "axios";
import md5 from "md5";

export default function FormSubmission({ isModalOpen }) {
    const { t } = useTranslation();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [errors, setErrors] = useState({
        userName: '',
        userEmail: '',
        userPhoneNumber: ''
    });

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
    });

    const [captcha, setCaptcha] = useState("");
    const [captchaInput, setCaptchaInput] = useState("");
    const [captchaError, setCaptchaError] = useState(false);

    const generateCaptcha = () => {
        const random = Math.floor(100000 + Math.random() * 900000); // 6 digit
        setCaptcha(random.toString());
    };

    useEffect(() => {
        generateCaptcha();
    }, []);

    useEffect(() => {
        if (!isModalOpen) {
            setFormData({
                name: "",
                email: "",
                phone: "",
            })
            setCaptcha("");
            generateCaptcha();
        }
    }, [isModalOpen]);

    const sendEmail = async (e) => {
        e.preventDefault();
        if (isSubmitting) return; // Prevent multiple submissions

        if (captchaInput !== captcha) {
            setCaptchaError(true);
            generateCaptcha(); // regenerate
            return;
        }

        setIsSubmitting(true);

        try {

            const uuid = '43e49695-424d-4f84-a31c-f87f0a9c3232';
            const secret = 'hF26YgpF7zuyp29SbxpRdO8BDLcGrkqElxo2Yz4f';

            const hash = md5(uuid + secret);
            
            await axios.post("https://mail-services.testflight4u.com/api/send-email", {
                sender: { name: formData.name, email: formData.email },
                to: [{ email: "marketing@currenttech.pro" }], // Replace with the recipient email
                subject: `Support Request from ${formData.name}`,
                htmlContent: `<p><strong>Phone:</strong> ${formData.phone}</p>`,
                method: 'api',
                uuid: uuid,
            }, {
                headers: {
                    "Content-Type": "application/json",
                    "x-api-key": hash,
                },
            });

            generateCaptcha(); // new captcha after success
            setFormData({ name: "", email: "", phone: "" });
            setCaptchaInput("");

            setTimeout(() => setIsSubmitted(false), 7000);
        } catch (error) {
            generateCaptcha();
            console.error('Error sending email:', error);
            alert('Failed to send message. Please try again later.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <form className="w-full" onSubmit={sendEmail}>
            <div className="flex flex-col items-center gap-[50px]">
                <div className="w-full flex flex-col items-center gap-5">
                    <div className="w-full flex flex-col items-center text-base font-semibold md:font-medium gap-[10px]">
                        <label>{t("MailForm.name")}</label>
                        <input 
                            type="text" 
                            name="name" 
                            className="w-full h-[40px] md:h-[50px] bg-[#DDD] rounded-[5px] px-3" 
                            required
                            value={formData.name}
                            onChange={(e) => setFormData('name', e.target.value)}
                        />
                        {errors.userName && <span className="text-red-500">{errors.userName}</span>}
                    </div>
                    <div className="w-full flex flex-col items-center text-base font-semibold md:font-medium gap-[10px]">
                        <label>{t("MailForm.email")}</label>
                        <input 
                            type="text" 
                            name="userEmail" 
                            className="w-full h-[40px] md:h-[50px] bg-[#DDD] rounded-[5px] px-3" 
                            required
                            value={formData.email}
                            onChange={(e) => setFormData('email', e.target.value)}
                        />
                        {errors.userEmail && <span className="text-red-500">{errors.userEmail}</span>}
                    </div>
                    <div className="w-full flex flex-col items-center text-base font-semibold md:font-medium gap-[10px]">
                        <label>{t("MailForm.phone")}</label>
                        <input 
                            type="number" 
                            name="userPhoneNumber" 
                            className="w-full h-[40px] md:h-[50px] bg-[#DDD] rounded-[5px] px-3 " 
                            required
                            value={formData.phone}
                            onChange={(e) => setFormData('phone', e.target.value)}
                        />
                        {errors.userPhoneNumber && <span className="text-red-500">{errors.userPhoneNumber}</span>}
                    </div>
                    <div className="flex flex-col gap-2 w-full">
                        <div className="flex flex-col md:flex-row items-center gap-3">
                            <div
                                className="px-6 py-3 bg-gray-200 rounded select-none relative overflow-hidden w-full md:w-auto text-center"
                                style={{
                                    fontSize: "32px",
                                    fontWeight: "bold",
                                    letterSpacing: "6px",
                                    transform: "rotate(0deg)",
                                    textShadow: "2px 2px 4px rgba(0,0,0,0.3)",
                                }}
                            >
                                {captcha.split("").map((char, index) => (
                                    <span
                                        key={index}
                                        style={{
                                            display: "inline-block",
                                            transform: `rotate(${Math.random() * 40 - 20}deg) `,
                                        }}
                                    >
                                        {char}
                                    </span>
                                ))}
                                <div className="absolute inset-0 pointer-events-none">
                                    <div className="w-full h-full bg-[repeating-linear-gradient(45deg,#ccc,#ccc_2px,#eee_2px,#eee_4px)] opacity-30"></div>
                                </div>
                            </div>
                            <button
                                type="button"
                                onClick={generateCaptcha}
                                className="text-base font-bold text-blue-500"
                            >
                                {t("Support.refresh")}
                            </button>
                        </div>

                        <input
                            type="number"
                            placeholder={t('Support.captcha_placeholder')}
                            value={captchaInput}
                            onChange={(e) => {
                                setCaptchaInput(e.target.value);
                                setCaptchaError(false);
                            }}
                            onPaste={(e) => e.preventDefault()}
                            className={`w-full h-[40px] md:h-[50px] bg-[#DDD] rounded-[5px] px-3 ${
                                captchaError ? "border-red-500" : "border-gray-300"
                            }`}
                        />

                        {captchaError && (
                            <span className="text-red-500 text-sm">
                                {t("Support.invalid_captcha")}
                            </span>
                        )}
                    </div>
                </div>
                <button type="submit" disabled={isSubmitting || (captchaInput !== captcha)} className="bg-black w-[200px] h-[50px] rounded-[10px] mt-[6px] md:mt-0 disabled:bg-gray-400 disabled:cursor-not-allowed disabled:text-gray-200">
                    <span className="text-white text-xl font-bold">{t("MailForm.button")}</span>
                </button>
            </div>
        </form>
    );
}
